const prefix = 'instance-detail-page';

export const i18n = {
    title: {
        id: `${prefix}.title`,
        defaultMessage: 'Instance details',
    },
    sectionDetails: {
        id: `${prefix}.sectionDetails`,
        defaultMessage: 'Details',
    },
    sectionDetailsDescription: {
        id: `${prefix}.sectionDetailsDescription`,
        defaultMessage: 'Identifying information for this instance.',
    },
    displayName: {
        id: `${prefix}.displayName`,
        defaultMessage: 'Display Name',
    },
    comment: {
        id: `${prefix}.comment`,
        defaultMessage: 'Comments',
    },
    salesforceId: {
        id: `${prefix}.salesforceId`,
        defaultMessage: 'Salesforce Account ID',
    },
    capacityGroupName: {
        id: `${prefix}.capacityGroupName`,
        defaultMessage: 'Capacity Group Name',
    },
    capacityGroupId: {
        id: `${prefix}.capacityGroupId`,
        defaultMessage: 'Capacity Group ID',
    },
    accountName: {
        id: `${prefix}.accountName`,
        defaultMessage: 'Account Name',
    },
    legalName: {
        id: `${prefix}.legalName`,
        defaultMessage: 'Legal Name',
    },
    edit: {
        id: `${prefix}.edit`,
        defaultMessage: 'Edit',
    },
    save: {
        id: `${prefix}.save`,
        defaultMessage: 'Save',
    },
    cancel: {
        id: `${prefix}.cancel`,
        defaultMessage: 'Cancel',
    },
    saveSuccess: {
        id: `${prefix}.saveSuccess`,
        defaultMessage: 'Instance updated',
    },
    saveError: {
        id: `${prefix}.saveError`,
        defaultMessage: 'Failed to update instance',
    },
    loadErrorTitle: {
        id: `${prefix}.loadErrorTitle`,
        defaultMessage: 'Could not load instance',
    },
    loadErrorMessage: {
        id: `${prefix}.loadErrorMessage`,
        defaultMessage: 'Please try again later.',
    },
    displayNameRequired: {
        id: `${prefix}.displayNameRequired`,
        defaultMessage: 'Display Name is required',
    },
    capacityGroupIdInvalid: {
        id: `${prefix}.capacityGroupIdInvalid`,
        defaultMessage: 'Must be a valid UUID',
    },
    subSideBarLabel: {
        id: `${prefix}.subSideBarLabel`,
        defaultMessage: 'Instance sections',
    },
    statusActive: {
        id: `${prefix}.statusActive`,
        defaultMessage: 'Active',
    },
    statusInactive: {
        id: `${prefix}.statusInactive`,
        defaultMessage: 'Inactive',
    },
    statusArchived: {
        id: `${prefix}.statusArchived`,
        defaultMessage: 'Archived',
    },
    discardChangesTitle: {
        id: `${prefix}.discardChangesTitle`,
        defaultMessage: 'Discard changes?',
    },
    discardChangesMessage: {
        id: `${prefix}.discardChangesMessage`,
        defaultMessage:
            'You have unsaved changes in this section. If you continue, your edits will be lost.',
    },
    discardChangesConfirm: {
        id: `${prefix}.discardChangesConfirm`,
        defaultMessage: 'Discard',
    },
    discardChangesKeep: {
        id: `${prefix}.discardChangesKeep`,
        defaultMessage: 'Keep editing',
    },
    deactivateButtonText: {
        id: `${prefix}.deactivateButtonText`,
        defaultMessage: 'Deactivate',
    },
    activateButtonText: {
        id: `${prefix}.activateButtonText`,
        defaultMessage: 'Activate',
    },
} as const;
